<template>
  <div class="main">
    <GoBack :name="`任务列表`" :type="2" :path="`/mobile/my`"></GoBack>

    <!-- 筛选框 -->
    <div class="screen-box2">
      <div class="left">
        <el-select
          v-model="year2"
          placeholder="参与年份"
          clearable
          @change="gethistoricalSurveys2(1)"
        >
          <el-option
            v-for="item in yearOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="input-box">
        <input v-model="number2" placeholder="任务编号" />
        <img
          @click="gethistoricalSurveys2(1)"
          src="@/assets/image/module/search.png"
        />
      </div>
    </div>

    <div class="content-box">
      <!-- <div class="herder-box">
        <div
          @click="active = 1"
          :class="['herder herder1', { active: active === 1 }]"
        >
          进行中 <span></span>
        </div>
        <div
          @click="active = 2"
          :class="['herder herder2', { active: active === 2 }]"
        >
          已参与 <span></span>
        </div>
      </div> -->

      <div
        class="list-box"
        v-if="active === 1"
        ref="scrollContainer"
        @scroll="handleScroll"
      >
        <div class="list-item" v-for="(item, index) in tableData2" :key="index">
          <div class="left">
            <div class="name1">{{ item.number }}</div>
            <div class="name2">{{ item.title }}</div>
            <!-- <div class="name3">无需审核</div> -->
          </div>
          <div class="right">
            <div class="name1">参与时间{{ item.joinDate | dateFrom }}</div>
            <div class="name2">{{ item.actualPoints }}金币</div>
            <div class="name3" v-if="item.state === 0">中途退出</div>
            <div class="name3" v-if="item.state === 1">被甄别</div>
            <div class="name3" v-if="item.state === 2">配额满</div>
            <div class="name3" v-if="item.state === 3">成功完成</div>
            <div class="name3" v-if="item.state === 4">审核拒绝</div>
            <div class="name3" v-if="item.state === 8">质量甄别</div>
          </div>
        </div>
        <div class="flag" v-if="!flag && tableData2.length !== 0">
          触底加载更多
        </div>
        <div class="flag" v-if="flag && tableData2.length !== 0">
          已经到底了~
        </div>

        <el-empty
          v-if="tableData2.length === 0"
          description="暂无数据"
        ></el-empty>
      </div>
      <div v-if="active === 2">
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>
<script>
import GoBack from "@/components/goBack.vue";
import { gethistoricalSurveys } from "@/api/mobile";
export default {
  filters: {
    dateFrom(data) {
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      active: 1,
      value1: null,
      value2: null,
      value3: null,
      menuTop: 86,
      options: [
        {
          value: 1,
          label: "已完成",
        },
        {
          value: 2,
          label: "未完成",
        },
        {
          value: 3,
          label: "其它",
        },
      ],
      yearOptions: [],
      tableData: [],
      tableData2: [],
      currentPage: 1,

      page2: 1,
      size2: 10,
      year2: null,
      title2: null,
      number2: null,

      flag: false,
      number: null,
    };
  },
  methods: {
    gethistoricalSurveys2(type) {
      if (type) {
        this.page2 = type;
        this.flag = false;
        this.tableData2 = [];
      }

      if (this.flag) {
        return;
      }
      gethistoricalSurveys({
        page: this.page2,
        size: this.size2,
        year: this.year2,
        title: this.title2,
        number: this.number2,
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            this.tableData2 = this.tableData2.concat(res.data.list);
            if (res.data.list.length === 10) {
              this.page2++;
            } else {
              this.flag = true;
            }
          }
        }
      });
    },
    handleScroll(e) {
      const container = this.$refs.scrollContainer;
      console.log(
        container.scrollTop + container.clientHeight,
        container.scrollHeight
      );

      // 检查是否接近底部
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        // 触底逻辑，例如加载更多数据
        console.log("触底");
        this.gethistoricalSurveys2();
      }
    },
  },
  created() {
    // 生成年份选项：当前年份往前数10年
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 10; i++) {
      const year = currentYear - i;
      this.yearOptions.push({
        value: year,
        label: `${year}年`,
      });
    }
    // 默认设置为当前年份
    this.year2 = currentYear;

    this.gethistoricalSurveys2();
  },
  components: {
    GoBack,
  },
};
</script>

<style lang="scss" scoped>
.flag {
  text-align: center;
  color: #999;
  font-size: 14px;
}
.main {
  min-height: 100vh;
  background-color: #f8f8fa;
  width: 100%;

  // 筛选移动端
  .screen-box2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background-color: #fff;
    margin-bottom: 10px;

    .left {
      flex: 1;
      margin-right: 10px;

      ::v-deep .el-select {
        width: 100%;
      }
    }

    .input-box {
      position: relative;
      flex: 1;

      input {
        width: 100%;
        height: 40px;
        background: #ffffff;
        border-radius: 20px;
        padding: 0 42px 0 12px;
        border: 1px solid #eee;
        outline: none;
        box-sizing: border-box;
        font-size: 14px;
      }

      img {
        position: absolute;
        right: 12px;
        width: 20px;
        height: 20px;
        top: 10px;
        cursor: pointer;
      }
    }
  }

  .content-box {
    height: calc(100vh - 140px);
    width: 100%;
    position: relative;
    .herder-box {
      display: flex;
      justify-content: space-between;
      height: 30px;
      position: absolute;
      z-index: 100;
      background-color: #f8f8fa;
      width: 100%;
      top: 0;
      .herder {
        color: #232323;
        font-size: 16px;
        line-height: 30px;
        position: relative;
      }
      .herder1 {
        margin-left: 47px;
      }
      .herder2 {
        margin-right: 47px;
      }
      .active {
        color: #8846ff;
        font-weight: bolder;
        span {
          position: absolute;
          display: block;
          width: 14px;
          height: 2px;
          background: #8846ff;
          border-radius: 10px 10px 10px 10px;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    .list-box {
      padding: 0 15px;
      padding-top: 10px;
      overflow-y: auto;
      overflow-x: hidden;
      height: calc(100vh - 140px);
      .list-item {
        width: 100%;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        .left {
          margin-left: 10px;
          color: #232323;
          font-size: 14px;
          .name1 {
            margin-top: 15px;
          }
          .name2 {
            font-weight: bolder;
            margin-top: 9px;
          }
          .name3 {
            font-size: 12px;
            color: #68ce80;
            margin-top: 12px;
            margin-bottom: 24px;
          }
        }
        .right {
          margin-right: 10px;
          text-align: right;
          display: flex;
          flex-direction: column;
          align-items: flex-end;

          .name1 {
            font-size: 12px;
            color: #999999;
            margin-top: 14px;
          }
          .name2 {
            font-size: 14px;
            color: #ffa200;
            margin-top: 11px;
            font-weight: bolder;
          }
          .name3 {
            color: #ff6017;
            font-size: 12px;
            margin-top: 7px;
            width: 44px;
            height: 24px;
            background-color: #fff6e5;
            line-height: 24px;
            text-align: center;
            color: #ffa200;
          }
        }
      }
    }
  }
}
</style>